const Vacations = () => {
    return ( <div>
        <h1>Vacations Page</h1>
    </div> );
}
 
export default Vacations;